import { SakitIcon, MualIcon, DemamIcon, PusingIcon, SehatIcon } from "./icons";

type HealthStatus = "SEHAT" | "TIDAK_FIT" | "SAKIT";
type Props = {
  score?: number;
  status?: HealthStatus;
  size?: number;
};

const HealthIcon = ({ score, status, size = 24 }: Props) => {
  const style = { width: size, height: size };
  if (typeof score === "number") {
    if (score <= 2) return <SakitIcon style={style} />;
    if (score <= 4) return <MualIcon style={style} />;
    if (score <= 6) return <DemamIcon style={style} />;
    if (score <= 8) return <PusingIcon style={style} />;
    return <SehatIcon style={style} />;
  }
  switch (status) {
    case "SEHAT":
      return <SehatIcon style={style} />;
    case "TIDAK_FIT":
      return <PusingIcon style={style} />;
    case "SAKIT":
      return <SakitIcon style={style} />;
    default:
      return null;
  }
};

export default HealthIcon;
